<template>
  <div class="customer-flow page-container">
    <QueryContainer v-model="searchLoading" @search="handleSearch" @reset="handleReset">
      <template v-slot:searchContent>
        <SearchForm v-model="searchQuery"></SearchForm>
      </template>
      <div slot="listContent">
        <el-radio-group size="small" v-model="searchQuery.status" @change="handleStatusChange">
          <el-radio-button v-for="item in statusList" :key="item.value" :label="item.value">{{
            item.label }}</el-radio-button>
        </el-radio-group>

        <div class="page-operation">
          <el-button size="small" icon="el-icon-plus" class="filter-item" @click="handleComeRecord">到店登记</el-button>
          <el-button size="small" class="filter-item" @click="handleExport">导出</el-button>
        </div>
        
        <!-- 列表 -->
         <div class="page-list">
          <CustomerFlowList :list="tableList" :loading="listLoading">
            <template v-slot:name="{ row }">
              <el-button type="text" size="small" @click="handleOpenDetail(row)">{{ row.name }}</el-button>
            </template>
            <template v-slot:mobile="{ row }">
              <Desensitize
                :text="row.mobile"
                :userType="4"
                :clearText="true"
                :queryKey="row.id"
                :key="row.id"
              />
            </template>
            <template v-slot:customerSource="{ row }">
              <span type="text" size="small">{{ formatterCustomerSource(row.customerSource) }}</span>
            </template>
            <template v-slot:arrivalType="{ row }">
              <span type="text" size="small">{{ formatterArrivalType(row.arrivalType) }}</span>
            </template>
            <template v-slot:operation="{ row }">
              <span v-if="row.status === CONSTANT_2">-</span>
              <el-button v-else type="text" size="small" @click="handleEdit(row)">离店</el-button>
            </template>
          </CustomerFlowList>
         </div>
         <!-- 分页 -->
        <div class="page-pagination">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            :total="total"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageParams.pageCount"
            :current-page="pageParams.page"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </QueryContainer>

    <!-- 到店登记 -->
    <ArrivalRegister
      :visible.sync="isArrivalRegister"
      :flowId="flowId"
      :assignMembers="assignMembers"
      :isDetail="isDetail"
      @change="(e)=> {
        isArrivalRegister=e
        isDetail=false
      }"
      @leaveRegister="handleLeaveRegister"
      @updateList="handleSearch"
    ></ArrivalRegister>
    
    <!-- 离店登记 -->
    <LeaveRegister
      :visible.sync="isLeaveRegister"
      :assignMembers="assignMembers"
      :flowId="flowId"
      :isDetail="isDetail"
      @change="(e)=>{
        isLeaveRegister=e
        isDetail=false
      }"
      @updateList="handleSearch"
    ></LeaveRegister>
  </div>
</template>

<script>
import SearchForm from './components/SearchForm.vue';
import { statusList, CONSTANT_2 } from './static/form-options';
import CustomerFlowList from './components/CustomerFlowList.vue';
import ArrivalRegister from './components/ArrivalRegister.vue';
import LeaveRegister from './components/LeaveRegister.vue';
import { mapActions, mapGetters } from 'vuex';
import Desensitize from "@/components/Desensitize/Desensitize.vue";

const searchInit = {
  customerInfo: '', // 客户信息
  customerSource: '', // 客户来源
  intentionLevel: '', // 意向级别
  arrivalTimeRang: [],// 到店时间
  leaveTimeRang: [],// 离店时间
  intentionSeries: '', // 意向车系
  isTestDrive: null,// 是否试驾
  hasOffer: null, // 是否报价
  hasBook: null, // 是否订车
  hasDeliver: null,// 是否交车
  registerStaff: null,
}

export default {
  components: {
    LeaveRegister,
    ArrivalRegister,
    CustomerFlowList,
    SearchForm,
    Desensitize
  },
  data() {
    return {
      CONSTANT_2,
      searchQuery: {
        ...searchInit,
        status: 0, // 状态
      },
      pageParams: {
        page: 1,
        pageCount: 10,
      },
      total: 0,
      searchLoading: false,
      listLoading: false,
      profile: {}, // 门店信息
      competitionSeriesList: [],
      seriesList: [],
      testDriveModel: [], // 试驾车型
      statusList,
      tableList: [],
      isArrivalRegister: false,
      isLeaveRegister: false,
      isAdmin: this.$common.getAdmin(),
      assignMembers: [],
      verifyArrivalInfo: {},// 到店信息校验
      flowId: null,
      isDetail: false,// 是否详情页面
    }
  },
  created() {
    this.profile = this.$common.getDealer();
    this.getMembers() // 获取门店成员
    this.getList()
    this.getSeriesList() // 获取意向车系
  },
  mounted() {
    this.getDealerRegion({ dealerId: this.profile.dealerId })
  },
  computed: {
    ...mapGetters('user',{
      storeProfile: 'profile'
    }),
    baseInfo() {
      return this.$common.getBaseInfo()
    },
    // 客户来源
    customerFlowSourcesUnion() {
      return this.baseInfo.customerFlowSourcesUnion
    },
  },
  methods: {
    ...mapActions('user', ['getDealerRegion']),
    // 获取意向车系
    getSeriesList() {
      this.$httpAuth
        .post("/v1/dealerRpc/seriesList", {
          dealerId: this.profile.dealerId
        })
        .then(res => {
          this.seriesList = res.data.records;
        });
    },
    // 获取门店成员
    getMembers() {
      this.$httpAuth
        .post("/v2/appDealerManagerService/memberList", {
          dealerId: this.profile.dealerId,
        }).then(e => {
          const { data } = e?.data ?? {};
          this.assignMembers = data.map(item => ({ label: item.userName, value: item.memberId }))
        })
    },
    formatterCustomerSource(customerSource) {
      return this.customerFlowSourcesUnion?.find(item => item.dataValue === customerSource)?.dataDisplay
    },
    formatterArrivalType(arrivalType) {
      return this.baseInfo.customerArrivalTypes?.find(item => item.dataValue === arrivalType)?.dataDisplay ?? ''
    },
    handleStatusChange() {
      this.pageParams.page = 1
      this.pageParams.pageCount = 10
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pageParams.page = 1
      this.pageParams.pageCount = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.getList();
    },
    handleSearch() {
      this.listLoading = true
      this.pageParams.page = 1
      this.pageParams.pageCount = 10
      this.getList()
    },
    getParams() {
      const params = { ...this.searchQuery }
      params.arrivalTime = {
        start: this.searchQuery.arrivalTimeRang?.[0] ?? '',
        end: this.searchQuery.arrivalTimeRang?.[1] ?? '',
      }
      delete params.arrivalTimeRang
      params.leaveTime = {
        start: this.searchQuery.leaveTimeRang?.[0] ?? '',
        end: this.searchQuery.leaveTimeRang?.[1] ?? '',
      }
      delete params.leaveTimeRang
      params.customerSource = params.customerSource ? String(params.customerSource): ''
      params.intentionLevel = params.intentionLevel ? String(params.intentionLevel): ''
      params.intentionSeries = params.intentionSeries ? String(params.intentionSeries): ''
      return params
    },
    getList() {
      const params = this.getParams()
      params.isExport = false
      this.$httpAuth.post("/v2/appCustomerFlowService/flowList", { 
        ...params,
        dealerId: this.profile.dealerId,
        pageCount: this.pageParams.pageCount,
        pageStart: (this.pageParams.page - 1) * this.pageParams.pageCount
     }).then(e => {
        const { data=[], total=0 } = e?.data ?? {}
        this.total = total
        this.tableList = data
      }).finally(() => {
        this.searchLoading = false
        this.listLoading = false
      })
    },
    handleExport() {
      const params = this.getParams()
      params.isExport = true
      const loading = this.$loading({
        lock: true,
        text: '正在导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$httpAuth.post("/v2/appCustomerFlowService/flowList", { 
        ...params,
        dealerId: this.profile.dealerId,
      }).then(e => {
        const { url, total } = e.data
        if(total > 2000) {
          this.$message({
            customClass: 'export-message',
            dangerouslyUseHTMLString: true,
            message: '<div>应安全要求，一次性最多只能导出2000条数据</div>',
            duration: 2000
          });
        }
        setTimeout(() => {
          loading.close()
          let a = document.createElement('a')
          a.href = url
          a.click()
        }, 1000)
      }).catch(() => {
          loading.close()
      })
    },
    handleReset() {
      this.listLoading = true
      this.searchQuery = {
        ...searchInit,
        status: this.searchQuery.status
      }
      this.getList()
    },
    handleComeRecord() {
      this.isArrivalRegister = true
    },
    handleEdit(row){
      this.flowId = row.id
      this.isLeaveRegister = true
    },
    handleOpenDetail(row) {
      this.isDetail = true
      this.flowId = row.id
      if (row.status === CONSTANT_2) {
        this.isLeaveRegister = true
      } else {
        this.isArrivalRegister = true
      }
    },
    handleLeaveRegister(e) {
      this.isLeaveRegister = true
      this.verifyArrivalInfo = e
      this.flowId = e.receptionFlowId
    }, 
  }
}
</script>

<style scoped>
.page-container {
  height: 100%;
  overflow: hidden;
}
.page-operation {
  margin-top: 10px;
}
.page-operation .el-button {
  margin-right: 10px;
}

.page-list {
  padding: 10px 0;
}

.page-pagination {
  margin-top: 20px;
}
</style>